/**
 * @since 1.0.0
 * @author ApMod Development Team
 *
 * This is meant for state management
 */

import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, ReplaySubject } from 'rxjs';
import { LoggerService } from './logger.service';

export interface ClientContext {
  user: any;
  refData: any;
  userPreferences: any;
  appConfig: any;
  isUserAuthorized: boolean;
  dynamicConfigs: any;
}

@Injectable({
  providedIn: 'root'
})
export class ClientContextService {

  private _clientContext: ClientContext = {
    user: {},
    refData: {},
    userPreferences: {},
    appConfig: [],
    isUserAuthorized: false,
    dynamicConfigs: {}

  };

  private _refData: any = {};

  private _userPreference: any = {};

  clientContext = this._clientContext;

  private _userProfile: any = {};

  private _clientContextSubject: BehaviorSubject<ClientContext> = new BehaviorSubject<ClientContext>(this._clientContext);
  private _profileSubject: BehaviorSubject<any> = new BehaviorSubject<any>(this._userProfile);
  private _refDataSubject: BehaviorSubject<any> = new BehaviorSubject<any>(this._refData);
  private _userPreferenceSubject: BehaviorSubject<any> = new BehaviorSubject<any>(this._userPreference);
  private _authorizedUserSubject: ReplaySubject<boolean> = new ReplaySubject<boolean>();
  constructor(private _logger: LoggerService) {

  }

  setUserPreferences(pref: object): void {
    this._clientContext.userPreferences = pref;
    this.setClientContext(this._clientContext);
    this._userPreferenceSubject.next(pref);
  }
  getUserPreferences(): Observable<object> {
    return this._userPreferenceSubject.asObservable();
  }

  isUserAuthorized(): Observable<boolean> {
    return this._authorizedUserSubject.asObservable();
  }

  setAuthorizedUser(isAuthorizedUser: boolean): void {
    this._clientContext.isUserAuthorized = isAuthorizedUser;
    this.setClientContext(this._clientContext);
    this._authorizedUserSubject.next(isAuthorizedUser);
  }

  setRefData(refData: object): void {
    this._clientContext.refData = refData;
    this.setClientContext(this._clientContext);
    this._refDataSubject.next(refData);
  }

  getRefData(): Observable<object> {
    return this._refDataSubject.asObservable();
  }
  
  setClientContext(clientContext: ClientContext): void {
    this.clientContext = clientContext;
    this._clientContextSubject.next(clientContext);
  }

  getClientContext(): Observable<ClientContext> {
    return this._clientContextSubject.asObservable();
  }

  setProfile(userProfile: object): void {
    this._logger.log('set profile is called');
    this._clientContext.user = userProfile;
    this.setClientContext(this._clientContext);
    this._profileSubject.next(userProfile);
  }

  getProfile(): Observable<any> {
    return this._profileSubject.asObservable();
  }

  getIdToken(): any {
    return localStorage.getItem('id_token');
  }
  getToken(): any {
    return localStorage.getItem('access_token');
  }

  getUserName(): any {
    return JSON.parse(localStorage.getItem('id_token_claims_obj'))['cognito:username'];
  }
  getUserEmail(): any {
    return JSON.parse(localStorage.getItem('id_token_claims_obj'))['email'];
  }
}
